import { render, staticRenderFns } from "./cloudButton.vue?vue&type=template&id=5d2158a7&scoped=true&"
import script from "./cloudButton.vue?vue&type=script&lang=js&"
export * from "./cloudButton.vue?vue&type=script&lang=js&"
import style0 from "./cloudButton.vue?vue&type=style&index=0&id=5d2158a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2158a7",
  null
  
)

export default component.exports